import logo from './logo.svg';
import './App.css';
import {
  BrowserRouter as Router, Routes,
  Route, Redirect,
} from "react-router-dom";
import Index from './components/dashboard/index';
import Service from './components/services/service';
import Contact from './components/contact/contact';
import EngineerService from './components/services/eng&consultancy';
import FireHydrant from './components/services/fireHydrant';
import FireSprinkler from './components/services/fireSprinkler';
import FireAlarm from './components/services/fireAlarm';
import PublicAddress from './components/services/publicAddress';
import AccessControl from './components/services/accessControl';
import TransformerProtection from './components/services/transformerProtection';
import IntegratedSecurity from './components/services/integratedSecurity';
import About from './components/about/about';
function App() {
  return (
    <>

    <Router>
      <Routes >

        <Route exact path="/" element={<Index />} />
        <Route path="/enginerringServices" element={<EngineerService />} />
        <Route path="/fireHydrant" element={<FireHydrant />} />
        <Route path="/fireSprinkler" element={<FireSprinkler />} />
        <Route path="/fireAlarm" element={<FireAlarm />} />
        <Route path="/publicAddress" element={<PublicAddress />} />
        <Route path="/accessControl" element={<AccessControl />} />
        <Route path="/transformerProtection" element={<TransformerProtection />} />
        <Route path="/transformerProtection" element={<TransformerProtection />} />
        <Route path="/integratedSecurity" element={<IntegratedSecurity />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />

        {/* <Route path="/gallery" element={<Gallery />} /> */}
      </Routes >
    </Router>
  </>
  );
}

export default App;
